import builder from '../builder';
import PinLocation1 from '../../streamline-icons/light/pin-location-1.svg';

export default builder('IconPinLocation1Light', PinLocation1);
